import { IconProps } from '@abstractTypes/icons'
export const CategoryTrainingIcon = ({
  width = '1rem',
  height = '1rem',
  fill = '#333',
  stroke = 'none',
  className = '',
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      className={className}
    >
      <path
        d="M46 23v-3a2 2 0 0 0-2-2h-3v-2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v7H15v-7a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v3H0v2h2v3a2 2 0 0 0 2 2h3v2a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-7h18v7a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h3a2 2 0 0 0 2-2v-3h2v-2h-2zM4 28v-8h3v8H4zm9 4H9V16h4v16zm26-12v12h-4V16h4v4zm5 8h-3v-8h3v8z"
        fill={fill}
      />
    </svg>
  )
}
